/**
 * REGOLE DI LAVORO — come si lavora in questa azienda.
 *
 * L'altra metà della vecchia scheda azienda: configurazione, campi e modelli di commessa,
 * preset orari, rendicontazione, pianificazione, turnazione, presenze e promemoria, ritardi,
 * modalità di lavoro, bacheca task. Si prende una decisione, e si cambia quando cambia la
 * decisione.
 *
 * ⚠️ Due di queste sezioni erano **anche** voci di menu — «Promemoria timbrature» e «Modalità
 * di lavoro» — cioè due porte sulla stessa configurazione, con due nomi. Da qui in avanti sono
 * sezioni e basta: `tests/unit/navGrouping.test.ts` fallisce se tornano nel menu.
 */
import { createFileRoute } from '@tanstack/react-router';
import { CompanyCard } from '@/features/tenants/CompanyCard';
import { WORK_RULE_SECTIONS } from '@/features/tenants/companySections';
import { parseCompanySearch } from '@/features/tenants/companySearch';

export const Route = createFileRoute('/_app/organization/work-rules')({
  validateSearch: parseCompanySearch,
  component: WorkRulesPage,
});

function WorkRulesPage() {
  return <CompanyCard sections={WORK_RULE_SECTIONS} to="/organization/work-rules" sectionTitle />;
}
